import React from 'react';
import { TClass } from '../model';

type TSubmodelListItemProps = {
    item: TClass;
    isSelected: boolean;
    onToggle: () => void;
}

const SubmodelListItem = ({ item, isSelected, onToggle } : TSubmodelListItemProps) => {

    return (
        <div onClick={onToggle} className="tw-flex tw-cursor-pointer tw-items-center tw-mb-2 tw-">
            <input
                type="checkbox"
                checked={isSelected}
                onChange={onToggle}  // Always call onToggle when radio button is clicked
                className="tw-mr-2"
            />
            <span className='tw-text-[#172B4D] tw-text-sm'>{item?.name ?? ''}</span>
        </div>
    );
};

export default SubmodelListItem;
